import React, { Component } from "react"

function addMeta(data) {
  data[$("meta[name=csrf-param]").attr("content")] = $("meta[name=csrf-token]").attr("content")
  return data
}

export default class EnableAutoArchive extends Component {
  changeValue(isAutoArchiveEnabled) {
    const url = `/super/organizations/${this.props.organization.id}/questionnaires/enable_auto_archive`

    $.ajax({
      url: url,
      type: "post",
      data: addMeta({is_auto_archive_on: isAutoArchiveEnabled ? 1 : 0}),
      success: () => this.props.updateIsAutoArchiveEnabled(isAutoArchiveEnabled)
    })
  }

  renderChoices() {
    return <select defaultValue={this.props.isAutoArchiveEnabled ? "1" : "0"}
                   onChange={e => this.changeValue(parseInt(e.target.value) == 1)}>
      <option value="1">Yes</option>
      <option value="0">No</option>
    </select>
  }

  render() {
    return <div className="row">
      <div className="col-sm-4">Enable Auto Archive?</div>
      <div className="col-sm-4">
        {this.renderChoices()}
      </div>
    </div>
  }
};